export default __webpack_public_path__ + "static/media/batch_pro.bb98bbc3.png";